import { useState, useEffect, useContext } from 'react';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { getReportList } from '../../api/reporting';
import { ReportingContext } from './ReportingContainer';

export const SelectReport = () => {
  const [data, setData] = useState([]);

  const { navToReportingPage, setReportId, setReportName } = useContext(ReportingContext);

  useEffect(() => {
    const fetch = async () => {
      const d = await getReportList();
      setData(d);
    };
    fetch();
  }, []);

  const columns = [
    {
      field: 'reportName',
      headerName: 'Name',
      flex: 1,
      headerClassName: 'table-header',
    },
    {
      field: 'select',
      headerName: 'Select',
      flex: 1,
      headerClassName: 'table-header',
      type: 'actions',
      getActions: ({ id, row }) => {
        return [
          <GridActionsCellItem
            key={id}
            icon={<ExitToAppIcon sx={{ pointer: 'cursor' }} />}
            label="Select"
            onClick={() => {
              setReportId(id);
              setReportName(row.reportName);
              navToReportingPage(1);
            }}
          />,
        ];
      },
    },
  ];

  return (
    <>
      <div className="settings-description">
        <span>Select a report to continue..</span>
      </div>
      <Paper sx={{ width: '100%' }}>
        <DataGrid
          rows={data}
          columns={columns}
          pageSizeOptions={[5, 10]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          sx={{ border: 0 }}
        />
      </Paper>
    </>
  );
};
